<div class="panel panel-font gradient-bg">
  <div class="panel-title"> {{ 'Odjezdy ze zastávky' | translate }} {{stop?.name}}</div>

  <a [routerLink]="'/'" class="closeBtn" title="{{ 'zavřít' | translate }}"></a>
  <button class="btn btn-primary blueBtn clickable right" *ngIf="stop" tabindex="0" (click)="openStreetview()">
    {{ 'Otevřít Streetview' | translate }}
  </button>

  <div class="panel-subtitle mt4" *ngIf="notice">{{notice | translate}}</div>
  <div class="panel-subtitle mt4" *ngIf="exceptionDescription">{{exceptionDescription}}</div>

  <div *ngIf="loading">
    <app-loading></app-loading>
  </div>

  <div *ngIf="departures.length > 0 && !loading">
    <ul class="mainList">
      <li *ngFor="let departure of departures" [routerLink]="['/detail', departure.id, stopId]" [queryParams]="{crId: departure.crId, crS: departure.crStop, crT: departure.crTtIndex, crD: departure.crDelayQuery}">
        <div class="panel-section clickable clickable-list">
          <div class="d-flex">
            <div class="icon{{departure.iconClass()}}new iconDiv">
              <span></span>
            </div>
            <div class="ml1">
              <div class="section-title">
                {{ getName(departure) }}
                <app-detour *ngIf="departure.isDetour"></app-detour>
              </div>
              <span>{{'směr' | translate}} </span><span class="fw-bolder">{{departure.destStation}} </span>
              @if (departure.platform) {
              <span>nást.</span><span class="platform">{{departure.platform}}</span>
              }
            </div>
            <div class="section-label-right">
              <div class="fw-bolder text-end">{{getDate(departure.depTime) | timeFormat}}</div>
              @if (departure.delay && departure.delay > 0)
              {
              <div class="panel-delay mt1">
                +&nbsp;{{departure.delay}}&nbsp;min
              </div>
              }
              @else
              {
              <div class="panel-no-delay mt1">
                {{ 'včas' | translate }}
              </div>
              }
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>
